import React, { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Wrapper that forces light mode by removing the dark class from the document.
 * Used for onboarding and 2FA setup screens which should always display in light mode.
 */
export default function ForceLightMode({ children }) {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    document.documentElement.classList.remove('dark');

    return () => {
      if (resolvedTheme === 'dark') {
        document.documentElement.classList.add('dark');
      }
    };
  }, [resolvedTheme]);

  return children;
}
